/*
 * Big Z's homepage bag: Clear all (2026-10-24, ZZ: "on the homepage when you do the your bag you want to clear all").
 * Loaded by layout/bz-v4.liquid right after bz-v4-commerce.js. The site-wide cart drawer already has Clear all
 * (data-bz-cart-clear, handled in bz-cart-add.js); the homepage bag (bz-v4-commerce.js) did not.
 *
 * While the bag shows items, a "Clear all" button sits in the bag's header next to the close button: the same spot
 * and style as Clear all in the homepage comparison view. One tap empties the cart with /cart/clear.js, like the
 * site-wide drawer. The bag then re-reads the cart, shows its empty state and says "Bag cleared."
 * The cart:update event it sends carries source "bz-cart-clear", so every other listener (ride-along shipping code,
 * lot discounts, header counts) treats it exactly like the drawer's Clear all.
 *
 * To turn it off, delete the bz-v4-bag-clear.js line in layout/bz-v4.liquid. bz-v4-commerce.js is not changed.
 */
(function () {
  'use strict';
  var w = window, d = document;
  if (w.__bzBagClear) return;
  w.__bzBagClear = 1;

  var busy = false, lastFocus = null;
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  // Same rules the comparison view's Clear all uses (bz-v4-shop.css), scoped to the bag view.
  var CSS = '.bz-v4-storefront .zui-view-cart .zui-dialog-head{gap:12px}' +
    '.bz-v4-storefront .zui-view-cart .zui-dialog-heading{margin-right:auto}' +
    '.bz-v4-storefront .zui-view-cart .zui-clear-bag{flex:none;min-width:48px;min-height:44px;margin:0;white-space:nowrap}' +
    '.bz-v4-storefront .zui-view-cart .zui-clear-bag:disabled{opacity:.5;cursor:default}';

  function zui() { return w.ZUI || null; }
  function pending() { var z = zui(); return !!(z && typeof z.isPending === 'function' && z.isPending()); }

  function addStyle() {
    if (d.getElementById('bz-bag-clear-css')) return;
    var s = d.createElement('style');
    s.id = 'bz-bag-clear-css';
    s.textContent = CSS;
    (d.head || d.documentElement).appendChild(s);
  }

  // Runs after every redraw of the bag (bz-v4-commerce.js rebuilds the whole dialog on each change).
  function place(dialog) {
    var head = dialog.querySelector('.zui-dialog-head');
    if (!head) return;
    var btn = head.querySelector('[data-bz-bag-clear]');
    var body = dialog.querySelector('.zui-cart-body');
    var want = /(^|\s)zui-view-cart(\s|$)/.test(dialog.className) && !!(body && body.querySelector('.zui-cart-item'));
    if (!want) { if (btn) btn.remove(); return; }
    var off = busy || pending() || body.getAttribute('aria-busy') === 'true';
    if (btn) { if (btn.disabled !== off) btn.disabled = off; return; }
    btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'zui-text-button zui-clear-bag';
    btn.setAttribute('data-bz-bag-clear', '');
    btn.setAttribute('aria-label', 'Clear all items from your bag');
    btn.textContent = busy ? 'Clearing…' : 'Clear all';
    btn.disabled = off;
    head.insertBefore(btn, head.querySelector('[data-z-close]'));
    // A redraw while Clear all had keyboard focus: give focus back to the new button.
    var a = d.activeElement;
    if (lastFocus && lastFocus.nodeType === 1 && lastFocus !== btn && !lastFocus.isConnected && lastFocus.hasAttribute('data-bz-bag-clear') && (!a || a === d.body) && dialog.open) {
      try { btn.focus({ preventScroll: true }); } catch (_) { btn.focus(); }
    }
  }

  function watch() {
    var dialog = d.querySelector('dialog.zui-dialog');
    if (!dialog) return false;
    addStyle();
    new MutationObserver(function () { place(dialog); })
      .observe(dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-busy'] });
    place(dialog);
    return true;
  }
  if (!watch()) {
    var tries = 0;
    var t = setInterval(function () { if (watch() || ++tries > 80) clearInterval(t); }, 250);
  }

  d.addEventListener('focusin', function (e) { lastFocus = e.target; });

  // After the tap: let the bag re-read the cart and redraw, then put focus somewhere sensible and show the note.
  function settle(dialog, msg, error) {
    var z = zui();
    var read = z && typeof z.refreshCart === 'function' ? Promise.resolve(z.refreshCart()).catch(function () { }) : Promise.resolve();
    return read.then(function () {
      if (dialog && dialog.open) {
        var a = d.activeElement;
        if (!a || a === d.body || !dialog.contains(a)) {
          var f = dialog.querySelector('[data-bz-bag-clear]:not(:disabled)') || dialog.querySelector('[data-z-find-fella]') || dialog.querySelector('[data-z-close]');
          if (f) { try { f.focus({ preventScroll: true }); } catch (_) { f.focus(); } }
        }
      }
      if (z && typeof z.toast === 'function') z.toast(msg, error);
    });
  }

  d.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bz-bag-clear]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || busy || pending()) return;
    var dialog = btn.closest('dialog');
    busy = true;
    btn.disabled = true;
    btn.textContent = 'Clearing…';
    fetch(root + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: '{}'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/clear.js ' + r.status);
        return r.json().catch(function () { return null; });
      })
      .then(function (cart) {
        busy = false;
        var canonical = cart && typeof cart.item_count === 'number' && Array.isArray(cart.items) ? cart : { item_count: 0, items: [] };
        d.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: canonical, sourceId: 'bz-bag-clear', data: { source: 'bz-cart-clear', itemCount: canonical.item_count } }
        }));
        return settle(dialog, 'Bag cleared.', false);
      }, function () {
        busy = false;
        return settle(dialog, 'Your bag could not be cleared. Try again.', true);
      })
      .then(function () {
        if (btn.isConnected) { btn.disabled = pending(); btn.textContent = 'Clear all'; }
      });
  });
})();
